import React from "react";

const Tag = ({ text, color = "gray" }) => {
  // Map Tailwind color variables
  const colorMap = {
    blue: { bg: "var(--color-blue-light)", text: "var(--color-blue-dark)" },
    green: { bg: "var(--color-green-light)", text: "var(--color-green-dark)" },
    yellow: { bg: "var(--color-yellow-light)", text: "var(--color-yellow-dark)" },
    purple: { bg: "var(--color-purple-light)", text: "var(--color-purple-dark)" },
    orange: { bg: "var(--color-orange-light)", text: "var(--color-orange-dark)" },
    red: { bg: "var(--color-red-light)", text: "var(--color-red-dark)" },
    gray: { bg: "var(--color-gray-100)", text: "var(--color-gray-800)" },
  };

  return (
    <span
      className="tw-paragraph-sm font-semibold inline-flex items-center justify-center px-3 py-1 rounded-[6px] w-fit capitalize"
      style={{
        backgroundColor: colorMap[color]?.bg || "var(--color-gray-100)",
        color: colorMap[color]?.text || "var(--color-gray-800)",
      }}
    >
      {text}
    </span>
  );
};

export default Tag;
